export enum CriticalTransmissionDate {
  Trapped = '12/31/2999',
  Cutoff = '12/31/3999',
  BadData = '12/31/3099',
}
